export class LanguageKeys {
  public static EN = 'en';
  public static FR = 'fr';
  public static DE = 'de';
  public static IT = 'it';
  public static NL = 'nl';
  public static ES = 'es';
  public static PT = 'pt';
}
